<template>
  <div>
    <rankings :is-sidebar="true" :edition="null"/>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'RightSidebar',
  components: {
    Rankings: defineAsyncComponent(() => import('./Rankings.vue')),
  },
}
</script>

<style scoped>

</style>